import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useCurrentDossierCtx, useDossierCustomHeader } from '@europrocurement/l2d-modules';
import { useFullLayout } from '@europrocurement/flexy-components';
import DetailDossierLeftNavBar from '../DetailDossierLeftNavBar/DetailDossierLeftNavBar';
import DossierBody from '../DossierBody/DossierBody';

const DetailDossierContainer: React.FunctionComponent = function () {
    const { setProfileHeaderVisible } = useFullLayout();
    const { dossier } = useCurrentDossierCtx();
    const { setIsDossierDetailPath, setHeaderTitle } = useDossierCustomHeader();

    // Update custom Header data, the actions will be set in the DetailDossierLeftNavBar
    useEffect(() => {
        if (dossier) {
            setIsDossierDetailPath(true);
            setProfileHeaderVisible(false);
            setHeaderTitle(`Dossier #${dossier?.numero} `);
        }
        return () => {
            setIsDossierDetailPath(false);
            setProfileHeaderVisible(true);
        };
    }, [dossier, dossier?.numero, setHeaderTitle, setIsDossierDetailPath, setProfileHeaderVisible]);

    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <DetailDossierLeftNavBar sx={{ width: '25%' }} />
            <Box sx={{ width: '75%' }}>
                <DossierBody />
            </Box>
        </Box>
    );
};

export default DetailDossierContainer;
